import moment from "moment"

function fetchRealData(unfilteredData, client) {
  if (!unfilteredData) return ""

  let body = unfilteredData
    .replaceAll("{clientName}", client?.clientName)
    .replaceAll("{clientEmail}", client?.email)
    .replaceAll("{UTRStatus}", client?.UTRStatus)

    .replaceAll("{tradingName}", client?.tradingName)
    .replaceAll("{correspondenceAddress}", client?.correspondenceAddress)
    .replaceAll("{businessNature}", client?.businessNature)
    .replaceAll("{websiteLink}", client?.websiteLink)

    .replaceAll(
      "{isUTRAgentAuthorisationApplied}",
      client?.isUTRAgentAuthorisationApplied
    )
    .replaceAll(
      "{UTRAgentAuthorisationAppliedDate}",
      moment(client?.UTRAgentAuthorisationAppliedDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{UTRAgentAuthorisationStatus}",
      client?.UTRAgentAuthorisationStatus
    )
    .replaceAll("{UTRAuthorisationCode}", client?.UTRAuthorisationCode)
    .replaceAll(
      "{UTRAgentAuthorisationLetterLocation}",
      client?.UTRAgentAuthorisationLetterLocation
    )
    .replaceAll(
      "{UTRAgentAuthorisationNotAppliedReason}",
      client?.UTRAgentAuthorisationNotAppliedReason
    )
    .replaceAll(
      "{isCACAgentAuthorisationApplied}",
      client?.isCACAgentAuthorisationApplied
    )
    .replaceAll(
      "{CACAgentAuthorisationAppliedDate}",
      moment(client?.CACAgentAuthorisationAppliedDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{CACAgentAuthorisationStatus}",
      client?.CACAgentAuthorisationStatus
    )
    .replaceAll("{CACAuthorisationCode}", client?.CACAuthorisationCode)
    .replaceAll(
      "{CACAgentAuthorisationLetterLocation}",
      client?.CACAgentAuthorisationLetterLocation
    )
    .replaceAll(
      "{CACAgentAuthorisationNotAppliedReason}",
      client?.CACAgentAuthorisationNotAppliedReason
    )
    .replaceAll(
      "{isPAYEAgentAuthorisationApplied}",
      client?.isPAYEAgentAuthorisationApplied
    )
    .replaceAll(
      "{PAYEAgentAuthorisationAppliedDate}",
      moment(client?.PAYEAgentAuthorisationAppliedDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{PAYEAgentAuthorisationStatus}",
      client?.PAYEAgentAuthorisationStatus
    )
    .replaceAll("{PAYEAuthorisationCode}", client?.PAYEAuthorisationCode)
    .replaceAll(
      "{PAYEAgentAuthorisationLetterLocation}",
      client?.PAYEAgentAuthorisationLetterLocation
    )
    .replaceAll(
      "{PAYEAgentAuthorisationNotAppliedReason}",
      client?.PAYEAgentAuthorisationNotAppliedReason
    )
    .replaceAll(
      "{isVATAgentAuthorisationApplied}",
      client?.isVATAgentAuthorisationApplied
    )
    .replaceAll(
      "{VATAgentAuthorisationAppliedDate}",
      moment(client?.VATAgentAuthorisationAppliedDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{VATAgentAuthorisationStatus}",
      client?.VATAgentAuthorisationStatus
    )
    .replaceAll("{VATAuthorisationCode}", client?.VATAuthorisationCode)
    .replaceAll(
      "{VATAgentAuthorisationLetterLocation}",
      client?.VATAgentAuthorisationLetterLocation
    )
    .replaceAll(
      "{VATAgentAuthorisationNotAppliedReason}",
      client?.VATAgentAuthorisationNotAppliedReason
    )
    .replaceAll("{UTRNumber}", client?.UTRNumber)
    .replaceAll("{CACNumber}", client?.CACNumber)
    .replaceAll(
      "{UTRAppliedDate}",
      moment(client?.UTRAppliedDate).format("DD.MM.YY")
    )
    .replaceAll("{CACStatus}", client?.CACStatus)
    .replaceAll("{PAYENumber}", client?.PAYENumber)
    .replaceAll("{PAYEStatus}", client?.PAYEStatus)
    .replaceAll("{VATNumber}", client?.VATNumber)
    .replaceAll("{VATStatus}", client?.VATStatus)
    .replaceAll("{insuranceNumber}", client?.insuranceNumber)
    .replaceAll("{insuranceStatus}", client?.insuranceStatus)
    .replaceAll("{letterLocationInsurance}", client?.letterLocationInsurance)
    .replaceAll("{clientType}", client?.clientType)
    .replaceAll("{clientCode}", client?.clientCode)
    .replaceAll("{companyHouseNumber}", client?.companyHouseNumber)
    .replaceAll("{registeredAddress}", client?.registeredAddress)
    .replaceAll("{clientUnderPracticeName}", client?.clientUnderPracticeId)
    .replaceAll("{clientStatus}", client?.clientStatusName)
    .replaceAll("{connectionId}", client?.connectionName)
    .replaceAll("{clientManagerName}", client?.clientManagerName)
    .replaceAll("{productionManagerName}", client?.productionManagerName)
    .replaceAll("{assistantName}", client?.assistantName)
    .replaceAll("{administratorName}", client?.administratorName)
    .replaceAll("{payrollManagerName}", client?.payrollManagerName)
    .replaceAll("{CISManagerName}", client?.CISManagerName)
    .replaceAll("{haveBookeeper}", client?.haveBookeeper)
    .replaceAll("{bookeeperName}", client?.bookkeeper?.preferredName)
    .replaceAll(
      "{bookeepingSystemName}",
      client?.bookkeepingSystem?.bookkeepingSystem
    )
    .replaceAll("{primaryPrefix}", client?.primaryPrefixData?.prefixName)
    .replaceAll("{primaryForename}", client?.primaryForename)
    .replaceAll("{primarySurname}", client?.primarySurname)
    .replaceAll("{primaryPreferredName}", client?.primaryPreferredName)
    .replaceAll(
      "{primaryDateOfBirth}",
      moment(client?.primaryDOB).format("DD.MM.YY")
    )
    .replaceAll("{primaryEmail}", client?.primaryEmail)
    .replaceAll("{primaryOccupation}", client?.primaryOccupation)
    .replaceAll("{primaryContactNumberFirst}", client?.primaryMobile)
    .replaceAll("{primaryContactNumberSecond}", client?.primaryLandline)
    .replaceAll("{primaryAddressLine1}", client?.primaryAddressLine1)
    .replaceAll("{primaryAddressLine2}", client?.primaryAddressLine2)
    .replaceAll("{primaryCity}", client?.primaryCity)
    .replaceAll("{primaryCountry}", client?.primaryCountry)
    .replaceAll("{primaryPostcode}", client?.primaryPostcode)
    .replaceAll(
      "{primaryContactDescription}",
      client?.primaryContactDescription
    )
    .replaceAll("{haveSecondaryContact}", client?.haveSecondaryContact)
    .replaceAll("{secondaryPrefix}", client?.secondaryPrefixData?.prefixName)
    .replaceAll("{secondaryForename}", client?.secondaryForename)
    .replaceAll("{secondarySurname}", client?.secondarySurname)
    .replaceAll("{secondaryPreferredName}", client?.secondaryPreferredName)
    .replaceAll(
      "{secondaryDateOfBirth}",
      moment(client?.secondaryDOB).format("DD.MM.YY")
    )
    .replaceAll("{secondaryOccupation}", client?.secondaryOccupation)
    .replaceAll("{secondaryEmail}", client?.secondaryEmail)
    .replaceAll("{secondaryContactNumberFirst}", client?.secondaryMobile)
    .replaceAll("{secondaryContactNumberSecond}", client?.secondaryLandline)
    .replaceAll("{secondaryAddressLine1}", client?.secondaryAddressLine1)
    .replaceAll("{secondaryAddressLine2}", client?.secondaryAddressLine2)
    .replaceAll("{secondaryCity}", client?.secondaryCity)
    .replaceAll("{secondaryCountry}", client?.secondaryCountry)
    .replaceAll("{secondaryPostcode}", client?.secondaryPostcode)
    .replaceAll(
      "{secondaryContactDescription}",
      client?.secondaryContactDescription
    )
    .replaceAll("{invoicingMethod}", client?.invoicingMethod?.invoicingMethod)
    .replaceAll("{paymentMethod}", client?.paymentMethod?.paymentMethod)
    .replaceAll("{serviceNameId}", client?.serviceNameId)
    .replaceAll("{totalAmount}", client?.grandTotal)
    .replaceAll("{monthlyOverride}", client?.monthlyOverride)
    .replaceAll("{letterLocationUTR}", client?.letterLocationUTR)
    .replaceAll("{letterLocationCAC}", client?.letterLocationCAC)
    .replaceAll("{letterLocationPAYE}", client?.letterLocationPAYE)
    .replaceAll("{letterLocationVAT}", client?.letterLocationVAT)
    .replaceAll(
      "{accountsAndTaxCurrentYearEndDate}",
      moment(client?.accountsAndTaxCurrentYearDueDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{accountsAndTaxCurrentYearDueDate}",
      moment(client?.accountsAndTaxNextYearDueDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{VATFirstPeriod}",
      moment(client?.VATFirstPeriod).format("DD.MM.YY")
    )
    .replaceAll(
      "{VATCurrentPeriodDueDate}",
      moment(client?.VATCurrentPeriodDueDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{VATCurrentPeriodEnd}",
      moment(client?.VATCurrentPeriodEnd).format("DD.MM.YY")
    )
    .replaceAll("{VATFrequency}", client?.VATFrequency)
    .replaceAll("{CISDate}", moment(client?.CISDate).format("DD.MM.YY"))
    .replaceAll("{CISDueDate}", moment(client?.CISDueDate).format("DD.MM.YY"))
    .replaceAll("{PAYEDate}", client?.PAYEDate)
    .replaceAll("{payrollFrequency}", client?.payrollFrequency)
    .replaceAll("{payrollFirstWeeklyDate}", client?.payrollFirstWeeklyDate)
    .replaceAll("{payrollSecondWeeklyDate}", client?.payrollSecondWeeklyDate)
    .replaceAll("{payrollFirstMonthlyDate}", client?.payrollFirstMonthlyDate)
    .replaceAll("{payrollSecondMonthlyDate}", client?.payrollSecondMonthlyDate)
    .replaceAll(
      "{payrollFirstFourWeeklyDate}",
      client?.payrollFirstFourWeeklyDate
    )
    .replaceAll(
      "{payrollSecondFourWeeklyDate}",
      client?.payrollSecondFourWeeklyDate
    )
    .replaceAll(
      "{payrollFirstFortNightlyDate}",
      client?.payrollFirstFortNightlyDate
    )
    .replaceAll(
      "{payrollSecondFortNightlyDate}",
      client?.payrollSecondFortNightlyDate
    )
    .replaceAll(
      "{bookkeepingFirstPeriodEnd}",
      moment(client?.bookkeepingFirstPeriodEnd).format("DD.MM.YY")
    )
    .replaceAll(
      "{bookkeepingCurrentPeriodEnd}",
      moment(client?.bookkeepingCurrentPeriodEnd).format("DD.MM.YY")
    )
    .replaceAll("{bookkeepingFrequency}", client?.bookkeepingFrequency)
    .replaceAll(
      "{bookkeepingCurrentPeriodDueDate}",
      moment(client?.bookkeepingCurrentPeriodDueDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{managementAccountFirstPeriodEnd}",
      moment(client?.managementAccountFirstPeriodEnd).format("DD.MM.YY")
    )
    .replaceAll(
      "{managementAccountCurrentPeriodEndDate}",
      moment(client.managementAccountCurrentPeriodEndDate).format(
        "MMMM DD, YYYY"
      )
    )
    .replaceAll(
      "{managementAccountFrequency}",
      client?.managementAccountFrequency
    )
    .replaceAll(
      "{managementAccountCurrentPeriodDueDate}",
      moment(client.managementAccountCurrentPeriodDueDate).format(
        "MMMM DD, YYYY"
      )
    )
    .replaceAll(
      "{CScurrentYearDate}",
      moment(client?.CScurrentYearDueDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{CScurrentYearDueDate}",
      moment(client?.currentCSYearDueDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{mostRecentKYCDate}",
      moment(client?.currentKYCDueDate).format("DD.MM.YY")
    )
    .replaceAll(
      "{nextKYCDueDate}",
      moment(client?.nextKYCDueDate).format("DD.MM.YY")
    )
    .replaceAll("{todaysDate}", moment().format("DD.MM.YY"))
    .replaceAll("{tradingStatus}", client?.trading)
    .replaceAll(
      "{personalCodeAppliedDate}",
      moment(client?.personalCodeAppliedDate).format("DD.MM.YY")
    )
    .replaceAll("{personalCode}", client?.personalCode)
    .replaceAll("{officerId}", client?.officerId)

  return body
}

export default fetchRealData
